import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-vendor-products-webhook-detail-dialog',
    templateUrl: './vendor-products-webhook-detail-dialog.component.html',
    styleUrls: ['./vendor-products-webhook-detail-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VendorProductsWebhookDetailDialogComponent {
  public form = this.formBuilder.group({
    createdAt: [''],
    vendor: [''],
    product: [''],
    action: [''],
    status: [''],
    payload: [{}],
  });

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<VendorProductsWebhookDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { item: any },
  ) {
    const item = data.item || {};
    this.form.patchValue({
      createdAt: item.createdAt,
      vendor: item.vendor,
      product: item.product,
      action: item.action,
      status: item.status,
      payload: item.payload || {},
    });
    this.form.disable();
    // Read-only JSON must stay enabled so the tree navigation remains clickable.
    this.form.controls.payload.enable();
  }

  close(): void {
    this.dialogRef.close();
  }
}
